import * as React from 'react'

const IconProgram = (props) => (
  <svg
    width={32}
    height={32}
    viewBox='0 0 32 32'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <defs>
      <path id='icon-programs_svg__a' d='M0 .692h25.027V28H.001z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M17.842 12.864a1.612 1.612 0 1 0 1.611 1.61c0-.887-.722-1.61-1.61-1.61'
        fill='#00B2E3'
      />
      <g transform='translate(3 1.308)'>
        <mask id='icon-programs_svg__b' fill='#fff'>
          <use xlinkHref='#icon-programs_svg__a' />
        </mask>
        <path
          d='m19.23 24.596-10.874.093a.569.569 0 0 0-.563.57c0 .884-.72 1.604-1.606 1.604H5.46c-.885 0-1.606-.72-1.606-1.605a.568.568 0 0 0-.568-.569h-2.15v-6.823h1.64A2.746 2.746 0 0 0 5.46 20.04h.727c1.32 0 2.425-.937 2.685-2.18l6.359-.087c.05 0 .098-.013.148-.015l3.859-.033a3.44 3.44 0 0 1 3.433 3.436 3.442 3.442 0 0 1-3.44 3.436zM1.138 1.828h19.318a3.44 3.44 0 0 1 3.436 3.436A3.44 3.44 0 0 1 20.455 8.7H15.95a4.492 4.492 0 0 0-.72-.073h-.007L9.869 8.7H8.36a.568.568 0 0 0-.568.568c0 .885-.72 1.605-1.606 1.605H5.46c-.885 0-1.606-.72-1.606-1.605a.568.568 0 0 0-.568-.568h-2.15V1.828zm10.958 11.338a2.75 2.75 0 0 1 2.747-2.747 2.75 2.75 0 0 1 2.748 2.747 2.75 2.75 0 0 1-2.748 2.747 2.75 2.75 0 0 1-2.747-2.747zm7.14 3.421h-.004l-.967.01a4.543 4.543 0 0 0 1.54-3.397 4.548 4.548 0 0 0-1.5-3.364h2.15a4.578 4.578 0 0 0 4.574-4.573A4.578 4.578 0 0 0 20.455.691H.569a.568.568 0 0 0-.568.57v23.997c0 .314.253.568.568.568h2.208A2.747 2.747 0 0 0 5.46 28h.727a2.748 2.748 0 0 0 2.685-2.178l10.364-.09a4.578 4.578 0 0 0 4.572-4.572 4.578 4.578 0 0 0-4.572-4.573z'
          fill='#00B2E3'
          mask='url(#icon-programs_svg__b)'
        />
      </g>
      <path
        d='M22.615 4.94c.888 0 1.61.723 1.61 1.61a1.61 1.61 0 1 1-1.61-1.611m0 4.359a2.75 2.75 0 0 0 2.747-2.747 2.75 2.75 0 0 0-2.747-2.747 2.75 2.75 0 0 0-2.747 2.747 2.75 2.75 0 0 0 2.747 2.747M15.938 4.94c.889 0 1.61.723 1.61 1.61a1.612 1.612 0 0 1-3.22 0c0-.887.722-1.61 1.61-1.61m0 4.358a2.751 2.751 0 0 0 2.748-2.747 2.75 2.75 0 0 0-2.748-2.747A2.75 2.75 0 0 0 13.19 6.55a2.75 2.75 0 0 0 2.747 2.747M21.88 24.01a1.612 1.612 0 0 1 0-3.221 1.612 1.612 0 0 1 0 3.22m0-4.357a2.75 2.75 0 0 0-2.748 2.748 2.75 2.75 0 0 0 2.747 2.747 2.75 2.75 0 0 0 2.747-2.747 2.75 2.75 0 0 0-2.747-2.748m-6.676 4.358a1.612 1.612 0 0 1 0-3.221 1.612 1.612 0 0 1 0 3.22m0-4.357a2.75 2.75 0 0 0-2.747 2.748 2.75 2.75 0 0 0 2.747 2.747A2.75 2.75 0 0 0 17.95 22.4a2.75 2.75 0 0 0-2.747-2.748'
        fill='#00B2E3'
      />
    </g>
  </svg>
)

export default IconProgram

